// TODO:
// 1-After changing the structure of Icons, change styled part of this script.

import { isPageDisabled } from "features/shared/lib/acl";
import { IS_ALLOWED_BY } from "features/shared/lib/configs";
import { createContext, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Navigate, Outlet, useLocation, useParams } from "react-router-dom";
import { setCurrentPageName } from "store/slices/routeName/routeNameSlice";

import { IsAllowed } from "../acl";
import { resources } from "../acl/resources";
import { useGetBulidingActiveTabs } from "../api/hooks/allHooks";
import { BuildingPassportHeader } from "../components/BuildingPassport/Header";
import { SecondaryNavbar } from "../components/BuildingPassport/SecondaryNavbar";
import { LoadingOrEmptyWrapper } from "../components/LoadingAndEmptyHandler";
import { getPageName } from "../utils/navigation";

export const ScreenShotContext = createContext();

export const BuildingPassportSharedLayout = () => {
  const { t } = useTranslation();

  const navLinks = [
    {
      dataKey: "building_profile",
      isAllowedBy: IS_ALLOWED_BY.BACKEND,
      linkName: t("BuildingPassportSharedLayout.building profile"),
      to: "buildingProfile",
    },
    {
      dataKey: "energy_co2",
      isAllowedBy: IS_ALLOWED_BY.BACKEND,
      linkName: t("BuildingPassportSharedLayout.Energy & CO₂"),
      to: "energyPerformance",
    },
    // {
    //   linkName: t("BuildingPassportSharedLayout.certificates"),
    //   to: "certificates",
    //   dataKey: "certificates",
    // },
    {
      dataKey: "technical_data",
      isAllowedBy: IS_ALLOWED_BY.BACKEND,
      linkName: t("BuildingPassportSharedLayout.technical Data"),
      to: "technicalData",
    },
    {
      dataKey: "modernization",
      isAllowedBy: IS_ALLOWED_BY.BACKEND,
      linkName: t("BuildingPassportSharedLayout.modernization"),
      to: "modernization",
    },
    IsAllowed(resources.EXECUTION.VIEW) && {
      dataKey: "execution",
      isAllowedBy: IS_ALLOWED_BY.FRONTEND,
      linkName: t("BuildingPassportSharedLayout.execution"),
      to: "execution",
    },
  ].filter(Boolean);

  const componentRef = useRef();
  const { projectId } = useParams();
  const dispatch = useDispatch();
  const { data, isLoading: tabsIsLoading } = useGetBulidingActiveTabs(projectId);
  const buildingActiveTabs = data || {};

  useEffect(() => {
    dispatch(setCurrentPageName("building passport"));
  }, []);

  const { pathname } = useLocation();
  const pageName = getPageName(pathname);

  const disabled = isPageDisabled({
    activePages: buildingActiveTabs,
    page: navLinks.find((link) => link.to === pageName),
  });

  if (disabled) return <Navigate to="/" />;

  return (
    <LoadingOrEmptyWrapper height="100vh" showLoading={tabsIsLoading}>
      <div>
        <BuildingPassportHeader componentRef={componentRef} pageName={pageName} projectId={projectId} />
        <section>
          <SecondaryNavbar activeTabs={buildingActiveTabs} className="mb-8 mt-4" navLinks={navLinks} />
          <ScreenShotContext.Provider value={componentRef}>
            <Outlet />
          </ScreenShotContext.Provider>
        </section>
      </div>
    </LoadingOrEmptyWrapper>
  );
};
